module.exports = __webpack_public_path__ + "static/graphic-hero-e575f0c751443b9e93650c07e28ebff9.jpg";